import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { tableDataTableStyles } from "./DataTable";

export function DataTableFHWAHeader({ isMetric }) {
  const { t } = useTranslation(["translation", "fhwa"]);
  //let isMetric = data.measurementType == 0;
  return (
    <>
      <View style={tableDataTableStyles.headerRow_Table}>
        {/* Layer Description */}
        <Text style={tableDataTableStyles.title_fhwa}>
          {t("aashto.ausser.Layer description_1")}
        </Text>
        {/* Windening */}
        <Text wrap style={tableDataTableStyles.title_fhwa}>
          {t("aashto.ausser.Widening")}
        </Text>
        {/* Layer Top */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("aashto.ausser.Layer top")}</Text>
        {/* Layer Bottom */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("aashto.ausser.Layer bottom")}</Text>
        {/* Length (inclined length) in layer */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("aashto.ausser.Inclined length")}</Text>
        {/* Ultimate skin friction */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("aashto.ausser.Skin friction")}</Text>
        {/* Factor of Safety */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("factorOfSafety", { ns: "fhwa" })}</Text>
        {/* Allowable skin friction */}
        <Text wrap="true" style={tableDataTableStyles.title_fhwa}>
          {t("aashto.ausser.Allowable skin friction")}
        </Text>
        {/* Load taken in Layer */}
        <Text wrap="true" style={tableDataTableStyles.title_fhwa}>
          {t("aashto.ausser.Load taken in layer")}
        </Text>
      </View>

      <View style={tableDataTableStyles.headerRowBottom}>
        <Text style={tableDataTableStyles.title_fhwa}>
          {t("aashto.ausser.Layer description_2")}
        </Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "mm" : "in"}]</Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "m" : "ft"}]</Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "m" : "ft"}]</Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "m" : "ft"}]</Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "kN/m²" : "psi"}]</Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "kN/m²" : "psi"}]</Text>
        <Text style={tableDataTableStyles.title_fhwa}>[{isMetric ? "kN" : "kip"}]</Text>
      </View>
    </>
  );
}
